import React from "react";

export default function Synonyms(props) {
  if (props.synonyms.length > 0) {
    return (
      <div>
        <br />
        <strong>Synonyms: </strong>
        <i>{props.synonyms.join(", ")}</i>
      </div>
    );
  } else {
    return null;
  }
}
